export const GET_AREAS = 'GET_AREAS';
export const AREA_REQUEST = 'AREA_REQUEST';
export const CREATE_AREA = 'CREATE_AREA';
export const UPDATE_AREA = 'UPDATE_AREA';
export const DELETE_AREA = 'DELETE_AREA';
export const AREA_REQUEST_FAILURE = 'AREA_REQUEST_FAILURE';
export const GET_AREAS_PAGE = 'GET_AREAS_PAGE';
export const AREA_REQUEST_SUCCESS = 'AREA_REQUEST_SUCCESS';